import { validaInstrumentoConfig } from "../valida-instrumento"
import type { ProductConfig } from "../type"

export const balancaConfig: ProductConfig = {
  ...validaInstrumentoConfig,
  product: {
    ...validaInstrumentoConfig.product,
    name: "Valida Balança",
    domains: [
      "balanca.primi.com.br",
      "www.balanca.primi.com.br",
      "balanca.homol.primi.com.br",
      "www.balanca.homol.primi.com.br",
    ],
  },
}
